import config from '../../config'

export const TRANSLATION_SERVICE_KEY = 'NY_TRANSLATION_SERVICE';
const TRANSLATIONS_STORAGE_KEY = 'NY_TRANSLATIONS';

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    NY_TRANSLATION_SERVICE: ITranslationService;
  }
}

export interface ITranslationService {
  initTranslations(projectId: string, countryCode: string): Promise<Translator>;
}

export function getTranslationService(): ITranslationService {
  const cs = window[TRANSLATION_SERVICE_KEY];
  if (cs) {
    return cs as ITranslationService;
  }
  return null
}

export class TranslationService implements ITranslationService {
  translations:any = null;

  async initTranslations(projectId: string, countryCode: string): Promise<Translator> {
    if (!this.translations) {
      this.translations = TranslationService.loadFromSessionStorage()
    }

    if (this.translations.hasOwnProperty(projectId)) {
      if (this.translations[projectId].hasOwnProperty(countryCode)) {
        return new Translator(projectId, countryCode, this.translations[projectId][countryCode]);
      }
    }

    const response = await fetch(`${config.translationUrl}/country/${countryCode.toLowerCase()}/${projectId}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET'
      });
    if (response.ok) {
      const translations = await response.json();
      const byCountryCode = {};
      byCountryCode[countryCode] = translations;
      this.translations[projectId] = byCountryCode;
      TranslationService.saveToSessionStorage(this.translations);
      return new Translator(projectId, countryCode, this.translations[projectId][countryCode])
    } else {
      if (countryCode === config.defaultLang) {
        return null;
      }
      return await this.initTranslations(projectId, config.defaultLang);
    }
  }

  private static loadFromSessionStorage():any {
    const translations = sessionStorage.getItem(TRANSLATIONS_STORAGE_KEY)
    if (translations) {
      return JSON.parse(translations);
    }
    return {};
  }

  private static saveToSessionStorage(translations: any) {
    sessionStorage.setItem(TRANSLATIONS_STORAGE_KEY, JSON.stringify(translations));
  }
}

export class Translator {
  constructor(private projectId: string, private countryCode: string, private translations: any) {}

  translate(key:string, ...params:string[]) {
    if (params && params.length > 0) {
      return this.replaceWildcards(key, params);
    }

    return this.translations[key] ? this.translations[key] : key
  }

  replaceWildcards(key, array) {
    let translation = this.translate(key);

    if (translation) {
      return translation.replace(/%[0-9]+\$s/g, (wildcard) => {
        let index = parseInt(wildcard.match(/\d+/g));
        return array[index - 1] ? array[index - 1] : wildcard;

      });
    } else
      return key;
  }

  getProjectId() {
    return this.projectId;
  }

  getCountryCode() {
    return this.countryCode;
  }
}
